import { useMemo } from 'react';

import { VisitAndAppointmentPrescriptionOnlyView } from '@dreryk/egabinet-visit-frontend-api';

import { TableDataAccessor } from '@dreryk/react-components';

import { PrescriptionVisitAdvancePaymentResolver } from './settlement/PrescriptionVisitAdvancePaymentResolver';
import { PrescriptionVisitSettlementResolver } from './settlement/PrescriptionVisitSettlementResolver';
import { isPrescriptionVisitSettlementAvailable } from './settlement/isPrescriptionVisitSettlementAvailable';

export const PrescriptionVisitsTableDataAccessor: TableDataAccessor<VisitAndAppointmentPrescriptionOnlyView> = (
   props
) => {
   const appointmentIds = useMemo<number[]>(() => props.currentPage.map((item) => item.appointmentId.asNumber()), [
      props.currentPage,
   ]);

   if (!isPrescriptionVisitSettlementAvailable()) {
      return null;
   }

   return (
      <>
         <PrescriptionVisitSettlementResolver appointmentIds={appointmentIds} />
         <PrescriptionVisitAdvancePaymentResolver appointmentIds={appointmentIds} />
      </>
   );
};
